import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const AdminRoute = ({ Component, type }) => {
  const { token } = useSelector((state) => state.auth);
  const [loading, setloading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setloading(true);
    if (type === "user" && token) {
      navigate("/profile");
    } else if (type === "profile" && !token) {
      navigate("/user");
    }
    setloading(false);
    return () => {};
  }, [navigate, type, token]);

  return <div>{loading ? <p>Loading...</p> : <Component />}</div>;
};
